import './index.scss'
import projects from '../../../data/projects'

const ArticleSharingDetail = () => {
	const project = projects.find((p) => p.slug === 'article-sharing-platform') || {}

	return (
		<main className="project-detail">
			<div className="site-container">
				<section className="project-detail__hero">
					<h1>{project.title}</h1>
                    <h3>{project.role} @ {project.organisation} ({project.timeline})</h3>
					{project.skills && (
						<ul className="project-detail__skills">
							{project.skills.map((s) => (
								<li key={s}>{s}</li>
							))}
						</ul>
					)}
				</section>

				<section className="project-detail__content">
				<p>{project.description}</p>
				{project.image && <img src={project.image} alt="Screenshot" className="project-detail__cover_image" />}

				<h3>Problem Overview</h3>
				<p>{project.problem_overview}</p>

				<h3>Implementation Details</h3>
                <p>{project.implementation_introduction}</p>
				<ul className="project-detail__implementation">
					{project.implementation_bullets.map((bullet, index) => (
						<li key={index}>{bullet}</li>
					))}
				</ul>
                <p>{project.implementation_paragraph}</p>

				<h3>Technical Approach</h3>
                <p>{project.technical_approach}</p>
                <p><b>Architecture</b></p>
				<div className='project-detail__architecture_image_box'>
                	{project.architecture_diagram[0] && <img src={project.architecture_diagram[0]} alt="Architecture Diagram" className="project-detail__architecture_image_1" />}
					{project.architecture_diagram[1] && <img src={project.architecture_diagram[1]} alt="Architecture Diagram" className="project-detail__architecture_image_2" />}
				</div>
                <p>{project.architecture_paragraph}</p>

				<h3>My Contribution</h3>
				<p>{project.contribution_introduction}</p>
                <ul className="project-detail__contribution">
					{project.contribution_bullets.map((bullet, index) => (
						<li key={index}>{bullet}</li>
					))}
				</ul>
                <div className='project-detail__contribution_images'>
                    <img src={project.evidence_images[0]} alt="Screenshot" className="project-detail__evidence_image" />
                    <img src={project.evidence_images[1]} alt="Screenshot" className="project-detail__evidence_image" />
                </div>
                <p>{project.contribution_paragraph}</p>

                <h3>Key Takeaways</h3>
                <p><b>This project gave me practical experience with: </b>{project.learned_knowledge.join(', ')}</p>

				<p><b>Technologies used:</b> {project.tech_bullets && project.tech_bullets.join(', ')}</p>

                <p><b>Report Unavaliable</b></p>
				</section>
			</div>
		</main>
	)
}

export default ArticleSharingDetail
